/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_Target_SeriesInputs */



/**
* | output |
* | --- |
* | "A recurring meeting" |
*
* @param {Meetings_Exception_Target_SeriesInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_target_series = /** @type {((inputs?: Meetings_Exception_Target_SeriesInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_Target_SeriesInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Een terugkerend gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une conversation récurrente")
	return /** @type {LocalizedString} */ ("A recurring meeting")
});